/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UpdateLifecycleStatesJobParams } from './updateLifecycleStatesJobParams';

/**
 * Request model for update lifecycle states job
 */
export interface RunUpdateLifecycleStatesJobRequest {
  type: 'update_lifecycle_states';
  params: UpdateLifecycleStatesJobParams;
  allowOverlappingJobs?: boolean;
}
